'use client';

import SimpleCalendar from '@/app/_home/_components/SimpleCalendar';
import CenterLayout from '@/layout/CenterLayout';
import DefaultLayout from '@/layout/DefaultLayout';

export default function CalendarPage() {
  return (
    <CenterLayout>
      <div className="pt-40 pb-[40px] w-full">
        {/* 캘린더 페이지에서는 전체 너비로 표시 */}
        <SimpleCalendar isFullWidth={true} />
      </div>
    </CenterLayout>
  );
}